import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="2wifhhi6tdh0t">
      <MetaPixel data-id="element-1" data-mp="28ufoebm15ej2" />
      <CountdownBar data-id="element-2" data-mp="28tw3qn4zwc1c" />
      <main data-id="element-3" data-mp="28t4m6g88geu2">
        <Hero data-id="element-4" data-mp="28suvsrja05nu" />
        <StatsBar data-id="element-5" data-mp="28sbcb6dz997p" />
        <Difference data-id="element-6" data-mp="23vck4tdvjcc5" />
        <Recognize data-id="element-7" data-mp="23vuoyeelqyvo" />
        <WhatsInside data-id="element-8" data-mp="23u9q4cl98ts0" />
        <InsidePages data-id="element-9" data-mp="23v2s7099qv3t" />
        <Bonuses data-id="element-10" data-mp="23ti6m04xmmi3" />
        <Offer data-id="element-11" data-mp="3ik7ekc2063oj" />
        <Guarantee data-id="element-12" data-mp="3ikqyfyb7r257" />
        <Testimonials data-id="element-13" data-mp="3ij65ue8glt9z" />
        <Faq data-id="element-14" data-mp="3ihv22ef0kliv" />
      </main>
      <Footer data-id="element-15" data-mp="3mlj6io8cn0zw" />
    </div>;
}